import Model from './BaseModel'
import Tag from './Tag'
import _ from 'lodash'
import axios from '@/plugins/axios'

export default class Media extends Model {
    request(config) {
        return axios.request(config)
    }

    formData() {
        let data = Object.entries(this.data())
        let formData = new FormData()

        data.forEach(row => {
            if (row[0] == 'tags') {
                row[1].forEach(tag => {
                    formData.append('tags[]', tag.id)
                })
            } else if (row[1]) {
                formData.append(row[0], row[1])
            }
        })

        return formData
    }

    create() {
        return this.makePersistRequest({
            url: this.resourceUrl(),
            method: 'POST',
            data: this.formData(),
        })
    }

    update() {
        let formData = this.formData()
        formData.append('_method', 'put')

        return this.makePersistRequest({
            url: this.getSelfUrl(),
            method: 'POST',
            data: formData,
        })
    }

    resourceName() {
        return 'marketing/medias'
    }

    fields() {
        return [
            'id',
            'title',
            'image_url',
            'height',
            'width',
            'description',
            'image',
            'active',
        ]
    }

    computed() {
        return {
            formattedTags(media) {
                let tags = _.map(media.tags, 'title')

                if (!tags.length) return ''

                return _.join(tags, ', ')
            },
        }
    }

    relationships() {
        return {
            tags: new Tag(),
        }
    }

    get searchable() {
        return ['title']
    }
}
